// Packages
import { useState, useEffect, React } from "react";
// import moment from "moment";
import PropTypes from "prop-types";
import { getFromLocalStorage } from "../../utils/webStorage";

// Material Ui
import { Typography } from "@material-ui/core";
import Box from "@material-ui/core/Box";
// Styles
import "./schoolAdmin.css";

// Services
import userService from "../../services/user.service";
import UserProfile from "../../Common/UserProfile";

// Utils

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function Coachprofile() {
  const [schoolData, setSchoolData] = useState({});
  const coachId = getFromLocalStorage("coachId");
  const schoolId = getFromLocalStorage("schoolId");
  const [assignSportsList, setAssignSportsList] = useState([]);
  const [groupAthletes, setGroupAthletes] = useState([]);
  const [activeSports, setActiveSports] = useState([]);
  const [adminRightsList, setAdminRightsList] = useState([]);
  const [activeRightsList, setActiveRightsList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getCoachData();
  }, []);

  const getCoachData = () => {
    setLoading(true);
    userService
      .getCoachDetails(coachId)
      .then((res) => {
        const data = res.data.data;
        setSchoolData(data);
        setGroupAthletes(data.groupCoaches);
        setActiveSports(data.assignedSports.map((item) => item.id));
        setActiveRightsList(data.permissionRights.map((item) => item.id));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getFilterSports();
    getAssignRightList();
  }, []);

  const getFilterSports = () => {
    userService.getSports(schoolId).then((response) => {
      if (response.data.status == true) {
        const filterSports = response.data.data;
        setAssignSportsList(filterSports);
      }
    });
  };
  const getAssignRightList = () => {
    userService.getAllPermissions().then((response) => {
      if (response.data.status === true) {
        const permissions = response.data.data.filter((item) => item.id !== 5);
        setAdminRightsList(permissions);
      }
    });
  };

  return (
    <div>
      <UserProfile
        schoolData={schoolData}
        groupAthletes={groupAthletes}
        assignSportsList={assignSportsList}
        activeSports={activeSports}
        adminRightsList={adminRightsList}
        activeRightsList={activeRightsList}
        flag="coach"
        URL="/coachpfmgmt"
        loading={loading}
      />
    </div>
  );
}

export default Coachprofile;
